import { validationTypes } from "../../../../../../../components/finalForms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../../../../../data/formFieldType";

const initialState = {
  dtDateEffective:null,
  dtEndDate:null,
  nCost:"",
  shippingCompany:"",
  strackingNumber:"",
};

export const editScopesConfig = {
  name: "Edit Scope",
  initialState: initialState,
  section: [
    {
      sectionId: "editScopeSection",
      title: "Edit Scope",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-12",
      },
      wrapperTemplate: <div className=""></div>, // Wrapper HTML or Component
      fields: [
        {
          id: "dtDateEffective",
          label: "Effective Date :",
          Field_Name: "Effective Date",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "dtDateEffective",
          fieldSetting: {
            placeholder: "Effective Date"
          },
          style: {
            containerCss: "col-lg-12 col-md-12 mb-2 po-to-datepicker po-input",
          },
          validation: [{ type: validationTypes.REQUIRE }],
        },
        {
          id: "dtEndDate",
          label: "End Date :",
          Field_Name: "End Date",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "dtEndDate",
          fieldSetting: {
            placeholder: "End Date"
          },
          style: {
            containerCss: "col-lg-12 col-md-12 mb-2 po-to-datepicker po-input",
          },
          validation: [{ type: validationTypes.REQUIRE }],
        },

        {
          id: "nCost",
          label: "Cost :",
          Field_Name: "Cost",
          fieldType: FormFieldTypes.INPUT,
          dataField: "nCost",
          fieldSetting: {
            placeholder: "Enter Cost",
          },
          style: {
            containerCss: "col-xxl-12 col-lg-12 mb-2 pr-0",
          },
          validation: [{ type: validationTypes.REQUIRE }],
        },

        {
          id: "shippingCompany",
          label: "Shipping Company :",
          Field_Name: "Shipping Company",
          fieldType: FormFieldTypes.SELECT,
          dataField: "shippingCompany",
          fieldSetting: {
            placeholder: "Enter Cost",
            options: [
              { label: "FedEx", value: "fedex" },
              { label: "UPS", value: "ups" },
            ],
          },
          style: {
            containerCss: "col-xxl-12 col-lg-12 mb-2 pr-0",
          },
          validation: [{ type: validationTypes.REQUIRE }],
        },

        {
          id: "strackingNumber",
          label: "Tracking Number :",
          Field_Name: "Tracking Number",
          fieldType: FormFieldTypes.INPUT,
          dataField: "strackingNumber",
          fieldSetting: {
            placeholder: "Enter Tracking Number",
          },
          style: {
            containerCss: "col-xxl-12 col-lg-12 mb-2 pr-0",
          },
        },

      ],
    },
  ],
};
